import React, { FC, useCallback } from 'react';
import { Menu } from 'src/common';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { usePreviewTabState } from 'src/models/procurements/hooks';
import { ActivePreviewTab } from 'src/models/procurements/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';

export const ProcurementPreviewNav: FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActivePreviewTab] = usePreviewTabState();

  const onChangeTab = useCallback(
    e => {
      setActivePreviewTab(e.key as ActivePreviewTab);
    },
    [setActivePreviewTab]
  );

  return (
    <Menu mode={'horizontal'} onClick={onChangeTab} selectedKeys={[activeTab]} className={styles.navTabs}>
      <Menu.Item key={ActivePreviewTab.Email} className={styles.navTab}>
        <span className={styles.navTab}>
          <FontAwesomeIcon icon={faEnvelope} className={styles.navTabIcon} />
          <span className={styles.navTabLabel}>{t('Common.email')}</span>
        </span>
      </Menu.Item>
    </Menu>
  );
};

export default ProcurementPreviewNav;
